import React, { Component } from "react";
import { connect } from "react-redux";
import { startLoading, stopLoading, closeModal } from "../../shared/actions";
import MobileChecker from "../../shared/utils/MobileChecker";

import { submitReferral } from '../actions';

import Modal from "../../shared/containers/Modal";
import ReferralForm from "../components/Form";

export class ReferralModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: "",
      contactNumber: "09",
      errors: {
        name: "",
        contactNumber: "",
      },
    }
  }

  resetForm = () => {
    this.setState({
      name: "",
      contactNumber: "09",
      errors: {
        name: "",
        contactNumber: "",
      }
    });
  }

  onChange = (e) => {
    const updatedState = { ...this.state }
    updatedState[e.target.name] = e.target.value;
    this.setState({...updatedState});
  }

  payload = () => {
    let utmCampaign = MobileChecker() ?  'fca_navbar_web_mobile' : 'fca_navbar_web_desktop'
    const { contactNumber, name } = this.state;
    const { user } = this.props;
    return {
      referrer_id: user.id,
      name: name,
      contact_number: contactNumber,
      utm_values: {
        utm_source: 'fca',
        utm_medium: 'fca-input',
        utm_campaign: utmCampaign,
        utm_content: 'help_a_friend_1',
      }
    }
  }

  validate = () => {
    const { name, contactNumber } = this.state;
    const isNumeric = new RegExp('^\\d+$');
    let errors  = {};
    let valid = true;
    if (name.split(' ').length < 2 || isNumeric.test(name)) {
      errors.name = "Please include the first and last name of your referral.";
      valid = false;
    }
    if (contactNumber.length < 11 || !isNumeric.test(contactNumber)) {
      errors.contactNumber = "This mobile number is not valid. It should be 11 numbers.";
      valid = false;
    }

    this.setState({errors: errors});
    return valid;
  }

  onSubmit = () => {
    if(this.props.loading) return;

    this.props.startLoading();
    if (this.validate()) {
      this.props.submitReferral(this.payload());
    } else {
      this.props.stopLoading();
    }
  }

  render() {
    const {
      name,
      contactNumber,
      errors,
    } = this.state;
    const { loading, closeModal } = this.props;

    return (
      <Modal name='referralModal' cardClassName="_tight" gridClassName="--narrow" data-testid="sample">
        <ReferralForm
          name={name}
          contactNumber={contactNumber}
          onChange={this.onChange}
          onSubmit={this.onSubmit}
          onClose={closeModal}
          errors={errors}
          loading={loading}
        />
      </Modal>
    )
  }

  componentDidUpdate(prevProps) {
    if(this.props.modal !== prevProps.modal && !this.props.modal) {
      this.resetForm()
    }
  }
}

const mapStateToProps = (state) => {
  return {
    company: state.company,
    modal: state.shared.ui.modal.referralModal,
    loading: state.shared.ui.loading.referralModal,
    user: state.user, };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    closeModal: () => dispatch(closeModal('referralModal')),
    startLoading: () => dispatch(startLoading('referralModal')),
    stopLoading: () => dispatch(stopLoading('referralModal')),
    submitReferral: (payload) => dispatch(submitReferral(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReferralModal);



// WEBPACK FOOTER //
// ./src/features/referrals/containers/Modal.js